import {
  UsergroupAddOutlined,
  UsergroupDeleteOutlined,
} from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { memo, useContext } from 'react';
import { ConversationContext } from '../../contexts/ConversationContext';

const RemoveGroupMemberForm = ({
  openModal,
  handleCancelModal,
  conversation,
  setOpenModalAdd,
}) => {
  const { removeUserFromGroupChat } = useContext(ConversationContext);

  return (
    <Modal
      open={openModal}
      title="Group members"
      onCancel={handleCancelModal}
      footer={[
        <Button
          ghost
          type="primary"
          key="add"
          onClick={() => setOpenModalAdd(true)}
          icon={<UsergroupAddOutlined />}
        />,
        <Button key="back" onClick={handleCancelModal}>
          Close
        </Button>,
      ]}
    >
      {conversation?.users?.map((user) => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          key={user?.id}
        >
          <p>{user?.fullName}</p>
          <Button
            danger
            icon={<UsergroupDeleteOutlined />}
            onClick={() => {
              removeUserFromGroupChat(conversation?.id, user?.id);
              handleCancelModal();
            }}
          />
        </div>
      ))}
    </Modal>
  );
};

export default memo(RemoveGroupMemberForm);
